import React, { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useDispatch } from "react-redux"

import { reset, setUserId } from "../../redux/inscription"
import Steps from "./steps"

const Inscription = () => {
  const location = useLocation()
  const dispatch = useDispatch()

  useEffect(() => {
    const { state }:any = location
    if (state && state.userId) dispatch(setUserId(state.userId))
    return () => {
      dispatch(reset())
    }
  }, [dispatch, location, location.search, location.state])

  return <Steps />
}

export default Inscription
